export default __webpack_public_path__ + "static/media/Arrow---Down-2.38ae0908.svg";